import moment from 'moment';
import React, { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { FaEdit, FaTrash } from 'react-icons/fa';

export const commaSeparatedTemplateTypes = ['prescription', 'diagnosis', 'complaint'];

export const useTemplateType = (t) => useMemo(() => {
	return [
		{ value: 'complaint', label: t('ALLOPATHY.NAV.COMPLAINTS') },
		{ value: 'diagnosis', label: t('ALLOPATHY.NAV.DIAGNOSIS') },
		{ value: 'prescription', label: t('GENERAL.PRESCRIPTION') },
	];
}, [t]);

export const useTemplateColumn = ({ t, currentPage, perPage, handleNameEdit, handleItemEdit, handleDelete, title, type }) => {
	return useMemo(() => [
		{
			name: '#',
			selector: (_, index) => (currentPage - 1) * perPage + index + 1,
			maxWidth: '55px',
			minWidth: '55px',
			center: true,
		},
		{
			name: t('GENERAL.NAME'),
			selector: row => row.name,
			wrap: true,
			sortable: true,
			sortField: 'name',
		},
		{
			name: t('GENERAL.DATE'),
			selector: row => moment(row.created_at).format('DD-MM-YYYY'),
			wrap: true,
			sortable: true,
			sortField: 'created_at',
		},
		{
			name: 'Update Name',
			cell: (row) => (
				<Button variant="success" size="sm" onClick={() => handleNameEdit(row)}>
					<FaEdit style={{ color: 'white' }} />
				</Button>
			),
			button: true,
			wrap: true,
			minWidth: '150px',
		},
		{
			name: 'Update Item',
			cell: (row) => (
				<Button variant="warning" size="sm" onClick={() => handleItemEdit(row)}>
					<FaEdit style={{ color: 'white' }} />
				</Button>
			),
			button: true,
			wrap: true,
			minWidth: '150px',
		},
		{
			name: 'Delete Template',
			cell: (row) => (
				<Button variant="danger" size="sm" onClick={() => handleDelete(row)}>
					<FaTrash style={{ color: 'white' }} />
				</Button>
			),
			button: true,
			wrap: true,
			minWidth: '150px',
		}
	], [t, currentPage, perPage, handleNameEdit, handleItemEdit, handleDelete, title, type]);
};
